import css from './product-ui-avatar.module.css';
import type { ReactNode } from 'react';
export type ProductUIAvatarStackProps = {
  children: ReactNode;
};
function ProductUIAvatarStack({
  children
}: ProductUIAvatarStackProps) {
  return <div className={css.avatarStack} data-sentry-component="ProductUIAvatarStack" data-sentry-source-file="product-ui-avatar-stack.tsx">{children}</div>;
}
export { ProductUIAvatarStack };